import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  className = '',
  onClick
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-214">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={() => {
      const el = document.getElementById('offer-block');
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
      onClick?.();
    }} className="w-full sm:w-auto bg-gold hover:bg-gold-dark text-white font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 text-lg sm:text-xl" data-id="element-215">
        <Zap className="w-5 h-5" data-id="element-216" />
        QUIERO RECUPERAR MI CALMA AHORA
      </motion.button>
      <div className="flex items-center gap-2 text-sm text-charcoal-light opacity-80" data-id="element-217">
        <Lock className="w-4 h-4" data-id="element-218" />
        <span data-id="element-219">Pago seguro. Acceso instantáneo a tu kit digital.</span>
      </div>
    </div>;
}